var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderButtonMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1.5,
    y: -1.68311,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1px)",
      clipPath: "url(#bgblur_0_2095_6988_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.3169,
    r: 15,
    fill: "#BFDCFF",
    fillOpacity: 0.8,
    stroke: "#3375AD",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2095_6988_clip_path",
    transform: "translate(1.5 1.68311)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.3169,
    r: 15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderButtonMain);
export default __webpack_public_path__ + "static/media/slider_button_main.6c31c853bd6a115a5b9cbe746601d37c.svg";
export { ForwardRef as ReactComponent };